/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-10-17",
    versionChannel: "nightly",
    buildDate: "2023-10-17T00:21:46.873Z",
    commitHash: "b02038bcd25d933ed9f114954e9b59bd6c45d71f",
};
